<script>
export default {
    name: "behaviorConfig",
    data() {
        return {
            form: {
                // 高频限制管控
                highFrequencyStatus: 2,
                highFrequencyTime: 24,
                highFrequencyCount: 0,
                // 切单风险管控
                switchOrderStatus: 2,
                switchOrderTime: 24,
                switchOrderCount: 0,
                switchOrderMinutes: 0,
            },
            loading: false,
            /**
             * 表单校验规则
             * @type {Object}
             */
            rules: {},
            disabled: true,
        }
    },
    created() {
        this.getInitFn()
    },
    watch: {
        // 监听开关变化，动态生成校验规则
        'form.highFrequencyStatus'(val) {
            console.log('val', val)
            this.generateRules()
            this.$nextTick(() => {
                this.$refs.form.validateField('highFrequencyCount')
            })
        },
        'form.switchOrderStatus': 'generateRules',
    },
    methods: {
        /**
         * 获取初始化数据并生成校验规则
         * @returns {Promise<void>}
         */
        async getInitFn() {
            const url = "/api/v1/manage/hitchRide/orderGrab/risk/config"
            const { code, data } = await this.$axios.get(url)
            if (code === 1 && data) {
                this.form = {
                    ...data,
                    highFrequencyStatus: data.highFrequencyStatus || 2,
                    highFrequencyTime: data.highFrequencyTime || 24,
                    switchOrderStatus: data.switchOrderStatus || 2,
                    switchOrderTime: data.switchOrderTime || 24
                }
            }
            this.generateRules();
        },
        /**
         * 动态生成表单校验规则
         * @returns {void}
         */
        generateRules() {
            const rules = {};
            rules.highFrequencyTime = [
                { required: this.form.highFrequencyStatus === 1, message: '请选择高频限制时间', trigger: 'change' }
            ];
            rules.highFrequencyCount = [
                { required: this.form.highFrequencyStatus === 1, message: '请输入高频限制累计取消单数', trigger: 'blur' }
            ];
            rules.switchOrderTime = [
                { required: this.form.switchOrderStatus === 1, message: '请选择切单风险时间', trigger: 'change' }
            ];
            rules.switchOrderCount = [
                { required: this.form.switchOrderStatus === 1, message: '请输入切单风险累计单数', trigger: 'blur' }
            ];
            rules.switchOrderMinutes = [
                { required: this.form.switchOrderStatus === 1, message: '请输入分钟内取消单数', trigger: 'blur' }
            ];
            this.rules = rules;
        },
        cancelForm() {
            this.disabled = true
            this.getInitFn()
        },
        async save() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    const url = "/api/v1/manage/hitchRide/orderGrab/risk/config"
                    const data = await this.$axios.post(url, this.form);
                    this.loading = false
                    if (data && data.code === 1) {
                        this.$message.success("保存成功！");
                        this.disabled = true
                        this.getInitFn()
                    }
                }
            });
        },
    }
}
</script>

<template>
    <div class="behaviorConfig">
        <div class="blueInfo util-remark">
            <i class="el-icon-warning" style="color: #409EFF;font-size: 16px; margin-right: 8px;"></i>
            <span>接单时，系统将根据以下配置，限制触发风控规则的司机抢单</span>
        </div>
        <div class="flex-between">
            <div class="formTitle">高频取消管控</div>
            <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
            <div v-else>
                <el-button @click="cancelForm">取消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
        </div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left" :disabled="disabled">

            <el-form-item label="规则状态">
                <div style="margin-bottom: 10px">
                    <el-switch v-model="form.highFrequencyStatus" :active-value="1" :inactive-value="2"></el-switch>
                    <span class="util-remark" style="display: inline-block; padding-left: 8px">如关闭，则抢单时不校验该风险</span>
                </div>
            </el-form-item>
            <el-form-item label="规则配置" prop="highFrequencyTime">
                <div class="flex">
                    <el-form-item>
                        <el-select v-model="form.highFrequencyTime"
                            style="width: 100px;margin-right: 8px;flex-shrink: 0;">
                            <el-option label="24小时内" :value="24"></el-option>
                            <el-option label="12小时内" :value="12"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="highFrequencyCount">
                        <el-input v-model="form.highFrequencyCount" maxlength="6"
                            v-input-filter="{ min: 0, max: 999, precision: 0 }" placeholder="">
                            <template slot="prepend">累计取消</template>
                            <template slot="append">单及以上，则禁止抢单</template>
                        </el-input>
                    </el-form-item>
                </div>
            </el-form-item>

            <div class="formTitle">切单风险管控</div>
            <el-form-item label="规则状态">
                <div style="margin-bottom: 10px">
                    <el-switch v-model="form.switchOrderStatus" :active-value="1" :inactive-value="2"></el-switch>
                    <span class="util-remark" style="display: inline-block; padding-left: 8px">如关闭，则抢单时不校验该风险</span>
                </div>
            </el-form-item>
            <el-form-item label="规则配置" prop="switchOrderTime">
                <div class="flex" style="gap: 8;">
                    <el-form-item label="" prop="switchOrderTime">
                        <el-select v-model="form.switchOrderTime"
                            style="width: 100px;flex-shrink: 0;">
                            <el-option label="24小时内" :value="24"></el-option>
                            <el-option label="12小时内" :value="12"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="switchOrderCount" style="flex:1; margin-left: 8px;">
                        <el-input v-model="form.switchOrderCount" maxlength="6"
                            v-input-filter="{ min: 0, max: 999, precision: 0 }" placeholder="">
                            <template slot="prepend">累计</template>
                            <template slot="append">单及以上</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="" prop="switchOrderMinutes" style="flex:1; margin-left: 8px;" >
                        <el-input v-model="form.switchOrderMinutes" maxlength="6"
                            v-input-filter="{ min: 0, max: 999, precision: 0 }" placeholder="">
                            <template slot="prepend">在接单</template>
                            <template slot="append">分钟内取消</template>
                        </el-input>
                    </el-form-item>
                </div>
            </el-form-item>
        </el-form>
    </div>
</template>

<style scoped lang="less">
.behaviorConfig {
    width: 900px;

    /deep/ .el-input-group__append,
    .el-input-group__prepend {
        background-color: #F5F7FA !important;
    }
}
</style>